import { render, staticRenderFns } from "./TicketIncomeView.vue?vue&type=template&id=397ecdcd&"
import script from "./TicketIncomeView.vue?vue&type=script&lang=js&"
export * from "./TicketIncomeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports